export enum GeneralReturnValue {
  CloseButton,
}
